import { GeneralEnterprise, PortfolioEnterpriseGroupResult } from '@mews-commander/data-access';
import { lt, showSuccessAlert, useDialogAction } from '@mews/framework';
import { useUpdatePropertyGroup } from '../queries';
import { DeletePropertiesDialog } from './DeletePropertiesDialog';

interface DeletePropertiesWrapperProps {
    propertyGroup: PortfolioEnterpriseGroupResult;
    selectedProperties: GeneralEnterprise[];
    renderButtonComponent: (onClick: () => void) => JSX.Element;
    onSuccess?: () => void;
}

export const DeletePropertiesWrapper = ({
    propertyGroup,
    selectedProperties,
    renderButtonComponent,
    onSuccess,
}: DeletePropertiesWrapperProps) => {
    const updatePropertiesMutation = useUpdatePropertyGroup();

    const deleteProperties = async () => {
        await updatePropertiesMutation.mutateAsync(
            {
                id: propertyGroup.id,
                propertyIdsToDelete: selectedProperties.map((property) => property.id),
            },
            {
                onSuccess: () => {
                    showSuccessAlert({
                        title: lt('PropertiesRemovedFromPropertyGroup', {
                            count: selectedProperties.length,
                            propertyGroupName: propertyGroup.name,
                        }),
                    });

                    onSuccess?.();
                },
            }
        );
    };

    const deleteAction = useDialogAction(deleteProperties);

    return (
        <>
            {renderButtonComponent(deleteAction.handlers.handleOpen)}
            {deleteAction.states.isDialogOpened ? (
                <DeletePropertiesDialog
                    propertyGroup={propertyGroup}
                    propertyCount={selectedProperties.length}
                    loading={updatePropertiesMutation.isPending}
                    deleteAction={deleteAction}
                />
            ) : null}
        </>
    );
};
